import { Invoice } from '@wonderschool/common-base-types';
import { ColorPaletteEnum } from '@wonderschool/common-base-ui';
import { useTranslation } from 'react-i18next';
import { InvoiceStatus as INVOICE_STATUS, invoiceStatusFormatter } from '../../../../helpers/invoices';
import { BadgeWithTooltip } from '../../BadgeWithTooltip';

/**
 * Maps invoice status to Badge ColorPaletteEnum
 */
const invoiceStatusColorMap: Record<string, ColorPaletteEnum> = {
  [INVOICE_STATUS.DRAFT]: ColorPaletteEnum.BLUE,
  [INVOICE_STATUS.OPEN]: ColorPaletteEnum.YELLOW,
  [INVOICE_STATUS.PAID]: ColorPaletteEnum.GREEN,
  [INVOICE_STATUS.UNCOLLECTIBLE]: ColorPaletteEnum.PINK,
  [INVOICE_STATUS.VOID]: ColorPaletteEnum.RED,
  [INVOICE_STATUS.SCHEDULED]: ColorPaletteEnum.PURPLE,
  [INVOICE_STATUS.FAILED]: ColorPaletteEnum.RED,
  [INVOICE_STATUS.PROCESSING]: ColorPaletteEnum.YELLOW,
  [INVOICE_STATUS.REFUND_STARTED]: ColorPaletteEnum.RED,
};

export const mapInvoiceStatusToBadgeColor = (status: string): ColorPaletteEnum => {
  return invoiceStatusColorMap[status] || ColorPaletteEnum.GRAY;
};
export type InvoiceStatusBadgeProps = {
  invoice: Invoice;
  withTooltip?: boolean | undefined;
};

export default function InvoiceStatusBadge({ invoice, withTooltip }: InvoiceStatusBadgeProps) {
  const { t } = useTranslation();
  const { color, text, popupText } = invoiceStatusFormatter(invoice, t);

  if (!color || !text) return null;

  const isFailedInvoice = invoice.status === INVOICE_STATUS.FAILED || invoice.status === INVOICE_STATUS.UNCOLLECTIBLE;
  const enablePopup = popupText && (isFailedInvoice || withTooltip);

  return (
    <BadgeWithTooltip
      label={t(text)}
      color={mapInvoiceStatusToBadgeColor(invoice.status)}
      tooltip={enablePopup ? t(popupText!) : undefined}
    />
  );
}
